import React from 'react';

const visi = () => {
    return (
        <article className="bg-light-pink pa3 pa5-ns tc">
            <h1 className="f3 f2-m f1-l">Visi dan Misi PKBM Hanuba</h1>
            <h4 className="f3 blue f2-m f1-l">Visi</h4>
            <p className=" tc">
            Terwujudnya masyarakat yang cerdas, terampil, mandiri, pruduktif menuju kehidupan yang sejahtera
  </p>
  <h4 className="f3 blue f2-m f1-l">Misi</h4>
            <p className="tc">
            -    Menyelenggarakan Pendidikan Non Formal.<br/>
-     Mengadakan pelatihan-pelatihan keterampilan maupun kewirausahaan<br/>
-  Mengupayakan Penambahan pengetahuan masyarakat melalui  praktek langsung di      lapangan kerja mitra PKBM Hanuba dan di tempat-tempat usaha PKBM.<br/>
- Memobilisasi sumber daya dan partisipasi masyarakat dalam upaya mendukung penyelenggaraan program pembelajaran dan pemberdayaan masyarakat
  </p>
        </article>


    );
}

export default visi;